/* Copyright (c) 2017 Backpack Health LLC */

import _ from 'lodash';
import { types as userActionTypes } from 'redux/actions/user';
import { types as sessionActionTypes } from 'redux/actions/session';
import groupSelectors from 'redux/reduxStore/group';

// import UserModel from '../../../models/UserModel';
import { authToken } from 'lib/storagePolyfill';

const initialState = {
  user: _.assign({
    profile_id: -1,
    email: '',
    locale_id: -1,
  }, _.get(authToken.decode(), 'user', {})),
  groupRoles: {
    lookup: {},
    collection: [],
  },
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case sessionActionTypes.LOG_OUT:
      return Object.assign({}, {
        user: {
          profile_id: -1,
          email: state.email,
          locale_id: state.user.locale_id,
        },
        groupRoles: {
          lookup: {},
          collection: [],
        },
      });
    case userActionTypes.SET_PREFERRED_LANGUAGE:
      const user = _.assign({}, state.user, {
        locale_id: action.payload.locale_id,
      });
      return _.assign({}, state, { user });
    case userActionTypes.UPDATE_EMAIL:
    case userActionTypes.UPDATE:
    case userActionTypes.RECEIVE:
      return _.assign({}, state, {
        user: {...state.user, ...action.payload },
      });
    case userActionTypes.RECEIVE_GROUP_ROLES:
      return _.assign({}, state, {
        groupRoles: action.payload,
      });
    case sessionActionTypes.LOG_IN_SUCCESSFUL:
      return _.assign({}, state, {
        user: {...state.user, ...action.payload.sessionToken.user },
      });
    default:
      return state;
  }
}

const selectors = {
  getEmail: (state) => state.user.user.email,
  getLocaleId: state => state.user.user.locale_id,
  getLoggedInUser: state => state.user.user,
  getUser: state => state.user.user,
  getMainProfileId: state => state.user.user.profile_id,
  isUserLoaded: state => !!state.user.user.cuid,
  groupRoles: state => state.user.groupRoles,
  roleForGroup: (state, groupId) => state.user.groupRoles.lookup[groupId],
  currentRole: state => {
    const groupId = groupSelectors.getActiveGroup(state).id;
    return _.get(state, `user.groupRoles.lookup[${groupId}].role`, null);
  },
};

export default selectors;
